function normalize(text: string): string {
  return text
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "");
}

export default function matchesSearch(text: string, query: string): boolean {
  return normalize(text).includes(normalize(query));
}
